import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IResourceItemResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IResourceItemResponseInstance'
import {mapFileResponseInstance} from '@toolify/client/src/modules/api/singletons/mapFileResponseInstance'

export function mapResourceItemResponseInstance(resourceItem: IToJson<IResourceItemResponseInstance>): IResourceItemResponseInstance {
  return {
    ...resourceItem,
    lastActivityAt: resourceItem.lastActivityAt ? new Date(resourceItem.lastActivityAt) : null,
    readAt: resourceItem.readAt ? new Date(resourceItem.readAt) : null,
    createdAt: new Date(resourceItem.createdAt),
    thumbnailFiles: resourceItem.thumbnailFiles
      ? resourceItem.thumbnailFiles.map(file => mapFileResponseInstance(file))
      : [],
  } as IResourceItemResponseInstance // TODO: TS: Remove "as ..."
}

